var exports = {
  "i": "x61f99309--b7cdba--wrapper",
};

module.exports = exports;
